import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2206_emp_grp_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Employee Group",
        style: {
            backgroundColor: "#F9FAFB"
        },
        fabAction: {
            type: "add",
            screenId: "2207",
            action: "hrm/emp_grp_add",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16
                },
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        titleValue: "group_name",
                        Name: "emp_grp_sumry",
                        SummeryActions: [
                            {
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "hrm/emp_grp_add/<id>"
                                },
                                ActionType: "Edit",
                                ScreenId: "2207",
                                visibility: [1],
                            },
                            {
                                Action: {
                                    Action: "Delete",
                                    Module: "emp_grp_sumry"
                                },
                                ActionType: "Delete",
                                ScreenId: "2207",
                                visibility: [1],
                            }
                        ],
                        Form: {
                            Name: "emp_grp_sumry",
                            TableName: "employee_group",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "id",
                                    BindValue: "id",
                                    Json_Attribute: "id",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: false
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Name",
                                    BindValue: "name",
                                    Json_Attribute: "group_name",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
];
